module.exports = __webpack_public_path__ + "fonts/MabryPro-Bold.6ccf37b6.woff";